module.exports = require("react-html5video");


//////////////////
// WEBPACK FOOTER
// external "react-html5video"
// module id = 188
// module chunks = 0